import { BaseEntity } from '../core/entities/base.entity';
import { Relation } from '../core/decorators/relation.decorator';
import { RelationRef } from '../core/types/entity-types';
import { ConsumerEntity } from '../consumer/consumer.entity';
import { SubjectEntity } from '../subject/subject.entity';
import { SequenceEntity } from '../sequence/sequence.entity';

export class TestEntity extends BaseEntity {
  name?: string;
  consumerId?: string;
  subjectId?: string;
  sequenceIds?: string[];
  kind?: string;
  consumerData?: string[];
  copyRestricted?: boolean;
  created_at?: Date;
  approval?: string;
  active?: boolean;
  version?: number;
  updated?: Date;
  changedBy?: string;

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];

  @Relation()
  sequences?: RelationRef<SequenceEntity>[];
}
